import React from 'react';
import { StarIcon } from 'lucide-react';
export function BabyTestimonials() {
  const testimonials = [{
    initials: 'MC',
    name: 'María C.',
    location: 'Bogotá, Colombia',
    quote: 'Antes improvisaba todos los días. Ahora ya no pienso: sé qué hacer.',
    rating: 5,
    color: 'pink'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Ciudad de México',
    quote: 'Ya no me da miedo cambiar texturas. Este ebook me dio confianza.',
    rating: 5,
    color: 'blue'
  }, {
    initials: 'SR',
    name: 'Sofía R.',
    location: 'Buenos Aires, Argentina',
    quote: 'Es como si alguien pusiera orden a todo lo que tenía guardado.',
    rating: 5,
    color: 'lavender'
  }];
  return <section id="testimonios" className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-baby-cream to-white" data-id="element-228">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-229">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in-up" data-id="element-230">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-231">
            Otras Mamás Dicen...
          </h2>
        </div>

        <div className="mb-8 sm:mb-12 animate-fade-in-up" style={{
        animationDelay: '0.2s'
      }} data-id="element-232">
          <div className="relative rounded-baby-lg overflow-hidden shadow-baby-glow" data-id="element-233">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ogvdD6nZvmB5KzB2VG5w28/9-mom_and_baby_scene_with_testimonial.png" alt="Testimonio real - Mamá feliz con su bebé después de usar el ebook" className="w-full h-auto" data-id="element-234" />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 sm:gap-8 stagger-children" data-id="element-235">
          {testimonials.map((testimonial, index) => <div key={index} className={`bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 ${testimonial.color === 'pink' ? 'border-baby-pink-light' : testimonial.color === 'blue' ? 'border-baby-blue-light' : 'border-baby-lavender'} shadow-baby-soft hover:shadow-baby-glow transition-all`} data-id="element-236">
              <div className="flex items-center gap-3 mb-4" data-id="element-237">
                <div className={`w-12 h-12 ${testimonial.color === 'pink' ? 'bg-baby-gradient-pink' : testimonial.color === 'blue' ? 'bg-baby-gradient-blue' : 'bg-baby-gradient-lavender'} rounded-full flex items-center justify-center text-white font-bold shadow-baby-soft`} data-id="element-238">
                  {testimonial.initials}
                </div>
                <div data-id="element-239">
                  <div className="font-semibold text-gray-900" data-id="element-240">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-gray-600" data-id="element-241">
                    {testimonial.location}
                  </div>
                </div>
              </div>

              <div className="flex gap-1 mb-4" data-id="element-242">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-243" />)}
              </div>

              <p className="text-sm sm:text-base text-gray-700 leading-relaxed italic" data-id="element-244">
                "{testimonial.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}